export default "__VITE_ASSET__DOv7HBBL__"